export const ui = {
  namespaced: true,
  state: {
    interstitial: {
      isLoading: false,
      message: ''
    }
  },

  getters: {
    getInterstitial: (state) => {
      return state.interstitial;
    }
  },

  mutations: {
    UPDATE_INTERSTITIAL (state, payload) {
      state.interstitial = payload;
    }
  },

  actions: {
    updateInterstitial ({ commit }, payload) {
      commit('UPDATE_INTERSTITIAL', payload);
    }
  }
};
